import { render, staticRenderFns } from "./IconeDoEvento.vue?vue&type=template&id=0cebfb19&scoped=true"
import script from "./IconeDoEvento.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconeDoEvento.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./IconeDoEvento.vue?vue&type=style&index=0&id=0cebfb19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cebfb19",
  null
  
)

export default component.exports